module.exports = __webpack_public_path__ + "static/img/horizontal.eedf520f.svg";